export function numberToWord(number: number, locale: string) {
  const translations: Record<string, string[]> = {
    en: ["one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "ten", "eleven", "twelve"],
    nb: ["en", "to", "tre", "fire", "fem", "seks", "sju", "åtte", "ni", "ti", "elleve", "tolv"],
    nn: ["ein", "to", "tre", "fire", "fem", "seks", "sju", "åtte", "ni", "ti", "elleve", "tolv"]
  };

  // Return the word based on the locale if the number is between 1 and 12
  if (number >= 1 && number <= 12) {
    return translations[locale][number - 1];
  }

  // Return the number itself if it is above 12
  return number.toString();
}
